import React from 'react';
import Modal, { ModalBody, ModalHeader, ModalTitle } from '../../../components/bootstrap/Modal';
import Icon from '../../../components/icon/Icon';

interface SearchHelpModalProps {
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
}

const SearchHelpModal: React.FC<SearchHelpModalProps> = ({ isOpen, setIsOpen }) => {
	return (
		<Modal isOpen={isOpen} setIsOpen={setIsOpen} titleId="search-help-modal" size="lg">
			<ModalHeader setIsOpen={setIsOpen}>
				<ModalTitle id="search-help-modal">
					<Icon icon="Search" className="me-2" />
					Global Search Guide
				</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<div className="row">
					<div className="col-md-6">
						<h6 className="fw-bold mb-3">
							<Icon icon="Keyboard" className="me-2 text-primary" />
							Keyboard Shortcuts
						</h6>
						<div className="list-group list-group-flush">
							<div className="list-group-item d-flex justify-content-between align-items-center">
								<span>Open Search</span>
								<kbd className="bg-light text-dark border">Ctrl + /</kbd>
							</div>
							<div className="list-group-item d-flex justify-content-between align-items-center">
								<span>Navigate Results</span>
								<div>
									<kbd className="bg-light text-dark border me-1">↑</kbd>
									<kbd className="bg-light text-dark border">↓</kbd>
								</div>
							</div>
							<div className="list-group-item d-flex justify-content-between align-items-center">
								<span>Select Result</span>
								<kbd className="bg-light text-dark border">Enter</kbd>
							</div>
							<div className="list-group-item d-flex justify-content-between align-items-center">
								<span>Close Search</span>
								<kbd className="bg-light text-dark border">Esc</kbd>
							</div>
						</div>
					</div>
					<div className="col-md-6">
						<h6 className="fw-bold mb-3">
							<Icon icon="Search" className="me-2 text-success" />
							Search Types
						</h6>
						<div className="list-group list-group-flush">
							<div className="list-group-item">
								<div className="d-flex align-items-center mb-2">
									<span className="me-2">💰</span>
									<strong>Transactions</strong>
								</div>
								<small className="text-muted">
									Search by reference number, amount, or transaction type
								</small>
								<div className="mt-1">
									<small className="badge bg-light text-dark">ZP-2025-001234</small>
								</div>
							</div>
							<div className="list-group-item">
								<div className="d-flex align-items-center mb-2">
									<span className="me-2">👤</span>
									<strong>Customers</strong>
								</div>
								<small className="text-muted">
									Search by name, phone number, or email
								</small>
								<div className="mt-1">
									<small className="badge bg-light text-dark">+220 123 4567</small>
								</div>
							</div>
							<div className="list-group-item">
								<div className="d-flex align-items-center mb-2">
									<span className="me-2">🏪</span>
									<strong>Agents</strong>
								</div>
								<small className="text-muted">
									Search by agent name, or phone
								</small>
								<div className="mt-1">
									<small className="badge bg-light text-dark">Omar Kanji Bah</small>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div className="row mt-4">
					<div className="col-12">
						<h6 className="fw-bold mb-3">
							<Icon icon="Lightbulb" className="me-2 text-warning" />
							Search Tips
						</h6>
						<div className="alert alert-info">
							<ul className="mb-0">
								<li>Search is case-insensitive and searches across multiple fields</li>
								<li>Partial matches are supported - try typing just a few characters</li>
								<li>Use phone numbers with or without country code</li>
								<li>Transaction references can be searched with or without prefixes</li>
								<li>Results are sorted by relevance and type</li>
							</ul>
						</div>
					</div>
				</div>
			</ModalBody>
		</Modal>
	);
};

export default SearchHelpModal;
